<template>
    <div class="AmazonReconciliation-container">
        <div class="select-box">
            <div class="select-item">
                <div class="label">开始日期：</div>
                <el-date-picker
                    v-model="startTime"
                    type="date"
                    placeholder="选择日期"
                    style="width: 180px"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"></el-date-picker>
            </div>
            <div class="select-item">
                <div class="label">结束日期：</div>
                <el-date-picker
                    v-model="endTime"
                    type="date"
                    style="width: 180px"
                    placeholder="选择日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"></el-date-picker>
            </div>
            <div class="select-item">
                <div class="label">公司：</div>
                <el-input placeholder="请输入公司" v-model="companyName" clearable></el-input>
            </div>
            <div class="select-item">
                <div class="label">店铺：</div>
                <el-input placeholder="请输入店铺" v-model="storeName" clearable></el-input>
            </div>
            <div class="select-item">
                <div class="label">订单号：</div>
                <el-input placeholder="请输入订单号" v-model="amazonOrderId" clearable></el-input>
            </div>
            <div class="select-item">
                <el-button type="primary" @click="handleQuery">查询</el-button>
            </div>
            <div class="select-item">
                <div class="label">交易一览状态：</div>
                <el-select v-model="transactionStatus" placeholder="请选择" clearable style="width: 180px"
                    @change="handleStatusChange">
                    <el-option label="不匹配" value="0"></el-option>
                    <el-option label="已匹配" value="1"></el-option>
                </el-select>
            </div>
            <div class="select-item">
                <div class="label">付款周期状态：</div>
                <el-select v-model="paymentCycleStatus" placeholder="请选择"  clearable style="width: 180px"
                     @change="handleStatusChange">
                    <el-option label="未入账" value="0"></el-option>
                    <el-option label="已入账" value="1"></el-option>
                </el-select>
            </div>
        </div>
        <el-table
            :data="tableData"
            border
            stripe
            style="width: 100%"
            height="660"
            v-loading="loading">
            <el-table-column prop="id" label="订单ID" width="150" align="center"></el-table-column>
            <el-table-column prop="companyFullName" label="公司" width="150" align="center"></el-table-column>
            <el-table-column prop="shopName" label="店铺名称" width="150" align="center"></el-table-column>
            <el-table-column prop="amazonOrderId" label="亚马逊订单号" width="180" align="center"></el-table-column>
            <!-- <el-table-column prop="companyFullName" label="公司名称" width="120"></el-table-column>
            <el-table-column prop="departmentName" label="部门名称" width="120"></el-table-column> -->
            <!-- <el-table-column prop="groupName" label="组名称" width="120"></el-table-column> -->
            <el-table-column prop="purchaseDate" label="下单日期" width="100" align="center"></el-table-column>
            <el-table-column prop="orderStatus" label="订单状态" width="80" align="center"></el-table-column>
            <!-- <el-table-column prop="quantity" label="订单数量" width="120"></el-table-column> -->
            <el-table-column prop="fulfillmentChannel" label="配送方式" width="80" align="center"></el-table-column>
            <el-table-column prop="currencyCode" label="币种" width="80" align="center"></el-table-column>
            <el-table-column prop="orderTotalAmount" label="订单总价" width="80" align="center"></el-table-column>
            <el-table-column prop="tax" label="税" width="80" align="center"></el-table-column>
            <el-table-column prop="feeAmount" label="佣金" width="80" align="center"></el-table-column>
            <el-table-column prop="csbaFee" label="客服费(平台)" width="100" align="center"></el-table-column>
            <el-table-column prop="refund" label="退款费用" width="80" align="center"></el-table-column>
            <el-table-column prop="refundCommission" label="退款管理费" width="100" align="center"></el-table-column>
            <el-table-column prop="orderActualCharge" label="实收费用" width="100" align="center"></el-table-column>
            <el-table-column label="交易一览数据（已发放）" width="150" align="left">
                <template slot-scope="scope">
                    <div v-for="(item, index) in scope.row.transactions" :key="index">
                        <!-- {{ transactionStatusMap[item.transactionStatus] ? transactionStatusMap[item.transactionStatus] : item.transactionStatus }}  -->
                        {{ transactionTypeMap[item.transactionType] ? transactionTypeMap[item.transactionType] : item.transactionType }}: {{ item.totalAmount }}
                    </div>
                    <div>合计：{{ scope.row.transactionsTotalAmount }}</div>
                    <div class="text-fukuan" :class="scope.row.transactionsDifference == 0 ? 'text-success' : 'text-danger'">差值：{{ scope.row.transactionsDifference }}</div>
                </template>
            </el-table-column>
            <el-table-column label="交易一览数据（延期发放）" width="150" align="left">
                <template slot-scope="scope">
                    <div v-for="(item, index) in scope.row.transactionsOther" :key="index">
                        <!-- {{ transactionStatusMap[item.transactionStatus] ? transactionStatusMap[item.transactionStatus] : item.transactionStatus }}  -->
                        {{ transactionTypeMap[item.transactionType] ? transactionTypeMap[item.transactionType] :
                        item.transactionType }}: {{ item.totalAmount }}
                    </div>
                    <div>合计：{{ scope.row.transactionsTotalAmountOther }}</div>
                    <div class="text-fukuan"
                        :class="scope.row.transactionsDifferenceOther == 0 ? 'text-success' : 'text-danger'">差值：{{
                            scope.row.transactionsDifferenceOther }}</div>
                </template>
            </el-table-column>
            <el-table-column label="付款周期数据" width="300" align="left">
                <template slot-scope="scope">
                    <div v-for="(item, index) in scope.row.payments" :key="index">
                        周期{{ index + 1 }}：
                        <template v-if="Object.keys(item).length > 0">
                            <div v-if="item['groupStart'] && item['groupEnd']">
                                {{ item['groupStart'] }} ~ {{ item['groupEnd'] }}
                            </div>
                            <div>
                                付款金额：{{ item.originalTotal }} {{ item.currencyCode }}
                                {{ item.paymentStatus ? '(已入账)' : '(未入账)' }}
                            </div>
                        </template>
                        <div v-else>暂无付款周期数据</div>
                    </div>
                    <el-button type="text" @click="getTransactionsBy(scope.row)">明细</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="付款周期明细" :visible.sync="dialogVisible" width="80%" top="8vh">
            <div class="dialog-content">
                <div v-for="(item, index) in dialogData" :key="index" class="dialog-item">
                    <div class="dialog-txt">
                        周期{{ index + 1 }} 
                        <template v-if="Object.keys(item).length > 0">
                            结算日期：{{ item.groupStart }} ~ {{ item.groupEnd }}
                            付款金额：{{ item.originalTotal }} {{ item.currencyCode }}

                            <span
                                v-if="paymentDetails[item.financialEventGroupId] && paymentDetails[item.financialEventGroupId].length > 0">
                                ( {{paymentDetails[item.financialEventGroupId].map(item11 => item11.totalAmount).join(' + ') }} = {{(paymentDetails[item.financialEventGroupId].reduce((sum, item11) => sum +
                                    item11.totalAmount, 0)).toFixed(2) }} )
                            </span>
                        </template>
                        <span v-else>暂无付款周期数据</span>
                    </div>
                    <el-table v-if="paymentDetails[item.financialEventGroupId] && paymentDetails[item.financialEventGroupId].length > 0" :data="paymentDetails[item.financialEventGroupId]" border stripe style="width: 100%">
                        <el-table-column prop="postedDate" label="日期" align="center"></el-table-column>
                        <el-table-column prop="accountType" label="账户类型" align="center">
                            <template slot-scope="scope">
                                {{ accountTypeMap[scope.row.accountType] ? accountTypeMap[scope.row.accountType] : scope.row.accountType }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="transactionType" label="交易类型" align="center">
                            <template slot-scope="scope">
                                {{ transactionTypeMap[scope.row.transactionType] ? transactionTypeMap[scope.row.transactionType] : scope.row.transactionType }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="orderId" label="订单编号" width="180" align="center"></el-table-column>
                        <el-table-column prop="region" label="区域"  align="center"></el-table-column>
                        <el-table-column prop="salesAmount" label="商品价格总额" align="center"></el-table-column>
                        <el-table-column prop="expensesAmount" label="亚马逊所收费用" align="center"></el-table-column>
                        <el-table-column prop="promoAmount" label="促销返点总额" align="center"></el-table-column>
                        <el-table-column prop="totalAmount" label="总金额" align="center"></el-table-column>
                        <el-table-column prop="currencyCode" label="币种" align="center"></el-table-column>
                    </el-table>
                </div>
            </div>
        </el-dialog>
        <!-- 分页 -->
        <div class="pagination">
            <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :page-sizes="[10, 20, 50, 100, 1000, 2000]"
                :page-size="pageSize"
                :current-page="currentPage"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { ajaxGet, ajaxPost, Baseurl } from '@/api/api/api.js';
import { getTableHeader, formatDate } from '@/assets/js/common.js'
export default {
    name: 'AmazonReconciliation',
    components: {},
    props: {},
    data() {
        return {
            startTime: '',
            endTime: '',
            storeName: '',
            companyName: '',
            amazonOrderId: '',
            tableData: [],
            historyData: [],
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            transactionTypeMap: {
                "Shipment": "订单发货",
                "Refund": "退款",
                "ProductAdsPayment": "广告费支出",
                "Adjustment": "调整",
                "Transfer": "转账/提款",
                "ServiceFee": "服务费",
                "SubscriptionFee": "订阅费",
                "CouponRedemption": "优惠券兑换",
                "DealFee": "Deal 费用",
                "LightningDealFee": "秒杀费用",
                "Reserve": "预留金",
                "FreeReplacementReturnCredits": "免费替换退货积分",
                "Other": "其他"
            },
            accountTypeMap: {
                "Standard Orders": "标准订单",
                "Invoiced Orders": "发票支付订单"
            },
            transactionStatusMap: {
                "RELEASED": "已结算",
                "DEFERRED": "已延期",
                "DEFERRED_RELEASED": "延期后释放"
            },
            dialogVisible: false,
            paymentDetails: {},
            dialogData: [],
            transactionStatus: '',
            paymentCycleStatus: '',
        };
    },
    created() { 
        const date = new Date();
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        this.endTime = `${year}-${month}-${day}`;
        if(month == '01'){
            this.startTime = `${year - 1}-12-31`;
        }else{
            this.startTime = `${year}-${(+month - 1).toString().padStart(2, '0')}-${day}`;
        }
        this.handleQuery();
    },
    mounted() { 
        
    },
    watch: {},
    computed: {},
    methods: {
        handleStatusChange(){
            const data = this.historyData.filter(item => {
                let transactionStatusMatch = true;
                let paymentCycleStatusMatch = true;
                if(this.transactionStatus !== ''){
                    transactionStatusMatch = item.transactionStatus == this.transactionStatus;
                }
                if(this.paymentCycleStatus !== ''){
                    paymentCycleStatusMatch = item.paymentStatus == this.paymentCycleStatus;
                }
                return transactionStatusMatch && paymentCycleStatusMatch;
            });
            this.tableData = data;
        },
        handleQuery(){
            this.loading = true;
            const params = {
                startTime: this.startTime + ' 00:00:00',
                endTime: this.endTime + ' 23:59:59',
                shopName: this.storeName,
                companyName: this.companyName,
                amazonOrderId: this.amazonOrderId,
                pageSize: this.pageSize,
                pageNum: this.currentPage
            };
            params['source'] = '1';
            ajaxPost(
                Baseurl + 'amazonSettlement/list', params
            ).then((res) => {
                const data = res.data;
                this.loading = false;
                const tableData = data.data.list;
                const paymentsMap = data.data.payments;
                for(let i = 0; i < tableData.length; i++){
                    const item = tableData[i];
                    if(item.transactions && item.transactions.length > 0){
                        let totalAmount = 0;
                        for(let j = 0; j < item.transactions.length; j++){
                            const transaction = item.transactions[j];
                            totalAmount += transaction.totalAmount;
                        }
                        item.transactionsTotalAmount = (+totalAmount).toFixed(2);
                        item.transactionsDifference = (item.orderActualCharge - +totalAmount).toFixed(2);
                        if(item.transactionsDifference == 0){
                            item.transactionStatus = '1';
                        }else{
                            item.transactionStatus = '0';
                        }
                    }else{
                        item.transactionStatus = '0';
                    }
                    if (item.transactionsOther && item.transactionsOther.length > 0) {
                        item.transactionsOther = item.transactionsOther.filter(item1 => item1.transactionStatus == 'DEFERRED_RELEASED');
                        let totalAmount = 0;
                        for (let j = 0; j < item.transactionsOther.length; j++) {
                            const transaction = item.transactionsOther[j];
                            totalAmount += transaction.totalAmount;
                        }
                        item.transactionsTotalAmountOther = (+totalAmount).toFixed(2);
                        item.transactionsDifferenceOther = (item.orderActualCharge - +totalAmount).toFixed(2);
                        // if (item.transactionsDifference == 0) {
                        //     item.transactionStatus = '1';
                        // } else {
                        //     item.transactionStatus = '0';
                        // }
                    } else {
                        // item.transactionStatus = '0';
                    }
                    let payments = [];
                    let paymentSuccessCount = 0;
                    const financialEventGroupId = item.financialEventGroupId;
                    if(financialEventGroupId){
                        payments = financialEventGroupId.split(',').map(item1 => {
                            const item111 = paymentsMap[item1] || {};
                            for(let j = 0; j < item.incomeExpenditureDetails.length; j++){
                                if(item111['originalTotal'] == item.incomeExpenditureDetails[j].amount){
                                    item111['paymentStatus'] = true;
                                    paymentSuccessCount ++;
                                    break;
                                }
                            }
                            return item111;
                        });
                    }
                    if(paymentSuccessCount == payments.length && payments.length > 0){
                        item.paymentStatus = '1';
                    }else{
                        item.paymentStatus = '0';
                    }
                    item.payments = payments;
                }
                this.tableData = tableData;
                this.historyData = JSON.parse(JSON.stringify(tableData));
                this.total = data.data.total;
            })
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.handleQuery();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.handleQuery();
        },
        getTransactionsBy(row) {
            const financialEventGroupId = row.financialEventGroupId;
            if(financialEventGroupId){
                ajaxPost(
                    Baseurl + 'amazonSettlement/getTransactionsByGroupId', { financialEventGroupId: financialEventGroupId }
                ).then((res) => {
                    const data = res.data;
                    if(data.code == 200){
                        this.paymentDetails = data.data;
                        this.dialogData = row.payments;
                        this.dialogVisible = true;
                    }else{
                        this.$message.warning('获取付款周期明细失败');
                    }
                })
            }else{
                this.$message.warning('该订单没有付款周期数据');
            }
        }
    },
};
</script>
<style lang="scss" scoped>
// 美化一下css
.AmazonReconciliation-container{
    .select-box{
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 20px;
        .select-item{
            display: flex;
            align-items: center;
            margin-right: 20px;
            margin-bottom: 10px;
            .label{
                width: 100px;
                text-align: right;
                margin-right: 10px;
                white-space: nowrap;
            }
        }
    }
    .table-box{
        margin-bottom: 20px;
    }
    .pagination{
        display: flex;
        justify-content: center;
        margin-top: 20px;
    }
}
.text-fukuan {
    font-weight: bold;
    &.text-success {
        color: green;
    }
    &.text-danger {
        color: red;
    }
}
/deep/ .el-table .cell .el-button{
    padding-left: 0;
}
/deep/ .dialog-item{
    margin-bottom: 20px;
    .dialog-txt{
        font-weight: bold;
        margin-bottom: 5px;
    }
}
</style>